import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import CallToAction from './components/CallToAction';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import Kosmetikstudio from './pages/Kosmetikstudio';
import Handwerker from './pages/Handwerker';
import Restaurant from './pages/Restaurant';
import Immobilienmakler from './pages/Immobilienmakler';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import './App.css';

// ScrollToTop component to handle scroll behavior on route changes
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // If there's a hash, scroll to that element
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <About />
    <Services />
    <Portfolio />
    <CallToAction />
    <Contact />
    <Footer />
    <Toaster />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kosmetikstudio" element={<Kosmetikstudio />} />
          <Route path="/handwerker" element={<Handwerker />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/immobilienmakler" element={<Immobilienmakler />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;